import React from "react";
import { useParams } from "react-router-dom";
import planData from "../../data/planData";
import PageWrapper from "../../components/PageWrapper";
import { Row, Col, Image } from "react-bootstrap";

const PlanDetails = () => {
  const { planType } = useParams();
  const data = planData[planType];

  if (!data) return <h2 className="text-center mt-5">Invalid Plan!</h2>;

  return (
    <PageWrapper title={data.title} subtitle={data.subtitle}>

      {/* INTRO SECTION */}
      <Row className="align-items-start mb-5">
        <Col md={8}>
          <h3 className="fw-bold">{data.introHeading}</h3>
          <p className="mt-3">{data.introText}</p>
        </Col>

        <Col md={4} className="text-center">
          <Image
            src={data.topImage}
            alt="Plan visual"
            fluid
            rounded
            className="shadow-sm"
          />
        </Col>
      </Row>

      {/* CORE FEATURES TITLE */}
      <h3 className="fw-bold text-center my-5 py-4 mb-4">Core Features</h3>

      {/* CORE FEATURE SECTIONS */}
      {data.coreFeatures.map((section, index) => (
        <div key={index} className="mb-4">
          <h5 className="fw-bold">{section.title}</h5>
          <ul className="mt-2 custom-bullets">
            {section.list.map((item, idx) => (
              <li key={idx} className="mb-1">{item}</li>
            ))}
          </ul>
        </div>
      ))}

      {/* WHY CHOOSE SECTION */}
      <Row className="align-items-center mt-5">
        <Col md={4} className="text-center mb-4 mb-md-0">
          <Image
            src={data.whyChoose.image}
            alt="Why choose visual"
            fluid
            rounded
            className="shadow-sm"
          />
        </Col>

        <Col md={8}>
          <h3 className="fw-bold">{data.whyChoose.title}</h3>
          <p className="mt-3">{data.whyChoose.content}</p>
        </Col>
      </Row>

    </PageWrapper>
  );
};

export default PlanDetails;
